<template>
  <div class="mc-cards">
    <div class="mc-card mc-card--destaque">
      <div class="mc-card__head">
        <div class="mc-card__icon mc-card__icon--light">
          <feather-icon
            icon="DollarSignIcon"
            size="22"
          />
        </div>
        <div class="mc-card__body-text">
          <div class="mc-card__valor">
            {{ report.headlineCustoTitulo || (report.headlineMoney + ' economizados') }}
          </div>
          <div class="mc-card__label-row">
            <div class="mc-card__label mc-card__label--inline">
              Custo economizado
            </div>
            <span
              v-b-tooltip.hover.top="tooltipCustoLongo"
              class="mc-card__help"
              tabindex="0"
              role="button"
              :aria-label="tooltipCustoLongo"
            >
              <feather-icon
                icon="HelpCircleIcon"
                size="16"
              />
            </span>
          </div>
          <p class="mc-card__hint-custo">
            {{ tooltipCustoCurto }}
          </p>
        </div>
      </div>
      <div class="mc-card__sep" />
      <p class="mc-card__sec">
        {{ report.horasEconomizadasLabel }}
      </p>
      <div class="mc-card__foot-block">
        <p class="mc-card__foot-title">
          {{ report.volumeRodapeTitulo }}
        </p>
        <p class="mc-card__foot-line">
          🤖 {{ report.volumeBotLinha }}
        </p>
        <p class="mc-card__foot-line">
          ⏱️ {{ report.volumeHumanoLinha }}
        </p>
        <p
          v-if="report.volumeExplicacaoSemBot"
          class="mc-card__foot-sem-bot-nota"
        >
          {{ report.volumeExplicacaoSemBot }}
        </p>
        <p class="mc-card__foot-contexto">
          {{ report.volumeMensagemFinal || report.volumeContextoLinha }}
        </p>
      </div>
    </div>

    <div class="mc-card mc-card--light mc-card--eficiencia">
      <div class="mc-card__ef-top">
        <div>
          <div class="mc-card__valor mc-card__valor--dark">
            x{{ report.velocidadeX }} <span class="mc-card__sub-valor">mais rápido</span>
          </div>
          <div class="mc-card__label mc-card__label--dark mc-card__label--small">
            Tempo médio de resolução (referência)
          </div>
          <div class="mc-card__row-destaque">
            <feather-icon
              icon="CheckCircleIcon"
              size="18"
              class="mc-card__check"
            />
            <span class="mc-card__min-bot">{{ botMinLabel }}</span>
          </div>
          <div class="mc-card__compare">
            <span>{{ botCompareLeft }} min</span>
            <feather-icon
              icon="ArrowRightIcon"
              size="14"
              class="mc-card__arrow"
            />
            <span>{{ botCompareRight }} min</span>
            <span class="mc-card__compare-hint">(referência humana)</span>
          </div>
        </div>
        <div class="mc-card__deco">
          <feather-icon
            icon="ZapIcon"
            size="48"
            class="mc-card__zap"
          />
        </div>
      </div>
      <div class="mc-card__foot-block mc-card__foot-block--light">
        <p class="mc-card__foot-title mc-card__foot-title--dark">
          {{ report.mediaRodapeTitulo }}
        </p>
        <p class="mc-card__foot-line mc-card__foot-line--dark">
          🤖 {{ report.mediaBotLinha }}
        </p>
        <p class="mc-card__foot-line mc-card__foot-line--dark">
          👩‍💻 {{ report.mediaHumanoLinha }}
        </p>
        <p class="mc-card__foot-micro">
          Valores médios por atendimento — não são soma do período.
        </p>
      </div>
    </div>

    <div class="mc-card mc-card--light">
      <div class="mc-card__valor mc-card__valor--dark mc-card__valor--pct">
        {{ report.pctAutomatizado }}%
      </div>
      <div class="mc-card__label mc-card__label--dark">
        Atendimentos automatizados
      </div>
      <p class="mc-card__aux">
        {{ report.conversasSemIntervencao }} conversas resolvidas sem intervenção humana
      </p>
    </div>
  </div>
</template>

<script>
import {
  TEXTO_CUSTO_TOOLTIP_CURTO,
  TEXTO_CUSTO_TOOLTIP_LONGO,
} from './relatorio-ia-bot-report'

export default {
  name: 'CardsResumoBot',
  props: {
    report: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      tooltipCustoCurto: TEXTO_CUSTO_TOOLTIP_CURTO,
      tooltipCustoLongo: TEXTO_CUSTO_TOOLTIP_LONGO,
    }
  },
  computed: {
    botMinLabel() {
      const v = this.report.botMinMedio
      if (v === '—' || v == null) return '—'
      return `${v} min (bot)`
    },
    botCompareLeft() {
      const v = this.report.botMinMedio
      return v === '—' || v == null ? '—' : v
    },
    botCompareRight() {
      const v = this.report.humanoMinComparacao
      return v === '—' || v == null ? '—' : v
    },
  },
}
</script>

<style scoped>
.mc-cards {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1.25rem;
  margin-bottom: 1.75rem;
}

@media (max-width: 991.98px) {
  .mc-cards {
    grid-template-columns: 1fr;
  }
}

.mc-card {
  border-radius: var(--mc-radius-lg);
  padding: 1.35rem 1.5rem;
  box-shadow: var(--mc-shadow-md);
  border: 1px solid transparent;
  transition: transform 0.22s ease, box-shadow 0.22s ease;
  min-height: 100%;
}

.mc-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 16px 34px rgba(93, 42, 140, 0.1);
}

.mc-card--destaque {
  background: var(--mc-gradient-card);
  color: #fff;
}

.mc-card--light {
  background: var(--mc-surface);
  border-color: var(--mc-border);
}

.mc-card__head {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
}

.mc-card__icon {
  width: 48px;
  height: 48px;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.mc-card__icon--light {
  background: rgba(255, 255, 255, 0.25);
  color: #fff !important;
}

.mc-card__label-row {
  display: flex;
  align-items: center;
  gap: 0.35rem;
  margin-bottom: 0.25rem;
}

.mc-card__label--inline {
  margin-top: 0 !important;
}

.mc-card__help {
  display: inline-flex;
  opacity: 0.85;
  cursor: help;
  color: inherit;
  padding: 0.1rem;
  border-radius: 50%;
  transition: opacity 0.2s ease, background 0.2s ease;
}

.mc-card__help:hover,
.mc-card__help:focus {
  opacity: 1;
  background: rgba(255, 255, 255, 0.2);
  outline: none;
}

.mc-card__hint-custo {
  font-size: 0.72rem;
  font-weight: 500;
  line-height: 1.35;
  margin: 0.4rem 0 0;
  opacity: 0.88;
  max-width: 100%;
}

.mc-card__valor {
  font-family: 'Plus Jakarta Sans', 'Inter', sans-serif;
  font-size: clamp(1.65rem, 3.5vw, 2.35rem);
  font-weight: 800;
  line-height: 1.05;
  letter-spacing: -0.02em;
}

.mc-card__valor--dark {
  color: var(--mc-text);
}

.mc-card__valor--pct {
  font-size: clamp(2rem, 4vw, 2.75rem);
}

.mc-card__sub-valor {
  display: inline-block;
  font-size: 0.42em;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  vertical-align: middle;
  margin-left: 0.15em;
}

.mc-card__label {
  font-size: 0.95rem;
  font-weight: 600;
  opacity: 0.95;
  margin-top: 0.35rem;
}

.mc-card__label--dark {
  color: var(--mc-text-soft);
  opacity: 1;
}

.mc-card__label--small {
  font-size: 0.82rem;
  margin-top: 0.5rem;
}

.mc-card__sep {
  height: 1px;
  background: rgba(255, 255, 255, 0.35);
  margin: 1rem 0;
}

.mc-card__sec {
  font-size: 1rem;
  font-weight: 600;
  margin: 0 0 1rem;
  opacity: 0.95;
}

.mc-card__foot-block {
  padding-top: 0.85rem;
  border-top: 1px solid rgba(255, 255, 255, 0.25);
}

.mc-card__foot-block--light {
  border-top-color: var(--mc-border);
  margin-top: 0.5rem;
  padding-top: 1rem;
}

.mc-card__foot-title {
  font-size: 0.68rem;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.07em;
  margin: 0 0 0.5rem;
  opacity: 0.88;
}

.mc-card__foot-title--dark {
  color: var(--mc-text-soft);
  opacity: 1;
}

.mc-card__foot-line {
  font-size: 0.84rem;
  font-weight: 700;
  margin: 0 0 0.25rem;
  opacity: 0.95;
}

.mc-card__foot-line--dark {
  color: var(--mc-text);
  font-weight: 700;
}

.mc-card__foot-sem-bot-nota {
  font-size: 0.68rem;
  font-weight: 500;
  line-height: 1.35;
  margin: 0.35rem 0 0;
  opacity: 0.78;
}

.mc-card__foot-contexto {
  font-size: 0.72rem;
  font-weight: 500;
  line-height: 1.4;
  margin: 0.55rem 0 0;
  opacity: 0.82;
}

.mc-card__foot-micro {
  font-size: 0.7rem;
  font-weight: 500;
  color: var(--mc-text-muted);
  margin: 0.5rem 0 0;
  line-height: 1.35;
}

.mc-card__aux {
  margin: 0.85rem 0 0;
  font-size: 0.9rem;
  font-weight: 500;
  color: var(--mc-text-soft);
  line-height: 1.45;
}

.mc-card__ef-top {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 0.75rem;
  margin-bottom: 0.25rem;
}

.mc-card__row-destaque {
  display: flex;
  align-items: center;
  gap: 0.35rem;
  margin-top: 0.65rem;
}

.mc-card__check {
  color: var(--mc-success);
}

.mc-card__min-bot {
  font-size: 1.2rem;
  font-weight: 800;
  color: var(--mc-text);
}

.mc-card__compare {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.35rem;
  margin-top: 0.5rem;
  font-size: 0.88rem;
  font-weight: 600;
  color: var(--mc-text-muted);
}

.mc-card__compare-hint {
  font-size: 0.72rem;
  font-weight: 600;
  color: var(--mc-text-muted);
  width: 100%;
  margin-top: 0.15rem;
}

.mc-card__arrow {
  color: var(--mc-purple-2);
}

.mc-card__deco {
  flex-shrink: 0;
  opacity: 0.55;
}

.mc-card__zap {
  color: var(--mc-purple);
}
</style>
